import { useState } from "react";
import { Button } from "@mui/material";

import LogsTable from "./LogsTable";
import { ProjectConfigSchema } from "hooks/pavm/base";

type LogsDialogProps = {
  name: string;
  data: string[];
  config: ProjectConfigSchema;
  updatedAt: string | Date | undefined;
  disabled?: boolean;
};

const LogsDialog = (props: LogsDialogProps) => {
  const disabled = props.disabled ?? false;

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div>
      <Button
        size="small"
        variant="contained"
        disabled={disabled}
        onClick={handleOpen}
      >
        View
      </Button>

      <LogsTable {...props} open={open} onClose={handleClose} />
    </div>
  );
};

export default LogsDialog;
